export const nearbySchools = state => {
  if (state.nearbySchools.status == 'success') {
    let schools = state.nearbySchools.schools;
    schools.forEach(school => {
      school.showInfo = false;
      if (school.hasShape) {
        let shape = JSON.stringify(school.shape);
        shape = shape.replace(/longitude/g, 'lng').replace(/latitude/g, 'lat').replace(/\":\"/g, '":').replace(/\",\"/g, ',"').replace(/\"\}/g, '}');
        school.shape = JSON.parse(shape);
      }
    });
  }
  return state.nearbySchools.schools;
}
